import React, { useContext, useEffect, useState } from "react";

// import TableOne from "../../../components/Dashboard/Tables/TableOne";

// import CardDataStats from "../../../components/Dashboard/CardDataStats";

import Profile from "../Profile";

// import CKeditorComponent from "../../../components/cKeditor/CKeditor";
import useAuth from "../../../hooks/useAuth";
import io from "socket.io-client";
import useRefreshToken from "../../../context/useRefreshToken";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import MatchCard from "../../../components/MatchCard/MatchCard";
import axios from "axios";
// import useSocket from "../../../components/useSocket";
import { ToastContainer } from "react-toastify";
import Loader from "../../../components/Loader";
import { useSocket } from "../../../context/SocketContext";
// import Joyride from "react-joyride";

const ECommerce = () => {
  const { authenticated, setAuthenticated } = useAuth();

  const axiosPrivate = useAxiosPrivate();
  const navgate = useNavigate();
  const refresh = useRefreshToken();
  const { socket } = useSocket(); // Backend URL
  const [loading, setloading] = useState(false);
  const [run, setRun] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (!authenticated) {
      navigate("/login");
    }
    if (authenticated?.user?.isVerified !== true) {
      navigate("/verifyEmail");
    }
    if (authenticated?.user?.joyride?.dashboard == false) {
      setRun(true);
      // setStepIndex(0);
    }
    let isMounted = true;
    const controller = new AbortController();

    const getUsers = async () => {
      try {
      } catch (error) {
        console.log(error);
        // { state: { from: location }, replace: true }
        navgate("/login");
      }
    };

    getUsers();

    return () => {
      isMounted = false;
      controller.abort();
    };
    // };
  }, []);

  const [listings, setListings] = useState([]);

  useEffect(() => {
    setloading(true);

    const fetchListings = async () => {
      await axiosPrivate
        .get("/listings/MatchCards", { withCredentials: true })
        .then((res) => {
          console.log(res.data);
          setListings(res.data);
          setloading(false);
        });
    };
    // Fetch initial listings

    fetchListings();
    // console.log("socket trying to run");
    // // Listen for new listings via Socket.IO
    const getSocket = async () => {
      await socket?.on("newListing", (newListing) => {
        console.log("socketiio");
        setListings((prevListings) => [newListing, ...prevListings]);
      });
    };
    getSocket();

    // Clean up the socket connection
  }, []);
  // useEffect(() => {}, [listings]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm();

  const handleReset = () => {
    // Reset to default values
    reset({
      game: "PUBG MOBILE",
      fees: "100-1000", // Example: filtering by fee range
      type: "All", // Example: filtering by type
      matchType: "All", // Example: filtering by match type
      server: "All", // or any default value you want to set
    });
  };

  const steps = [
    {
      target: ".myfilterstep",
      content:
        "These are the filters, search and find matches. All matches are shown only the current date.",
    },
    {
      target: ".totalMatchesstep",
      content: "You will find all the matches here!!",
    },
    {
      target: ".singleMatchDetails",
      content:
        "See all the match details carefully before participating as data is updated real-time ad slots might get full!, your balance is very important!",
    },
  ];

  const handleJoyrideCallback = async (data) => {
    const { status, action } = data;

    if (status === "finished") {
      console.log("Guide completed. No steps left.");
      // Add custom code here when all steps are completed
      const formData = {
        joyride: { dashboard: true },
      };
      await axiosPrivate
        .put("/users/updateUser", formData, {
          withCredentials: true,
        })
        .then((res) => {
          console.log(res.data);

          setAuthenticated((prevState) => ({
            ...prevState, // Spread the previous state
            user: {
              ...prevState.user, // Spread the previous user object
              joyride: {
                ...prevState.user.joyride, // Spread the previous joyride object
                dashboard: true, // Update only the dashboard property
              },
            },
          }));
          setRun(false);

          // setUserImage(null);
        })
        .catch((err) => console.log(err));
    }

    if (status === "skipped") {
      console.log("Guide skipped by the user.");
      const formData = {
        joyride: { dashboard: true },
      };
      await axiosPrivate
        .put("/users/updateUser", formData, {
          withCredentials: true,
        })
        .then((res) => {
          console.log(res.data);
          setAuthenticated((prevState) => ({
            ...prevState, // Spread the previous state
            user: {
              ...prevState.user, // Spread the previous user object
              joyride: {
                ...prevState.user.joyride, // Spread the previous joyride object
                dashboard: true, // Update only the dashboard property
              },
            },
          }));
          setRun(false);

          // setUserImage(null);
        })
        .catch((err) => console.log(err));
      // Add custom code for skip action
      setRun(false);
    }

    if (action === "close") {
      console.log("Guide was closed manually.");
      setRun(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <div>
        <div>
          {/* {authenticated?.user?.joyride?.dashboard == false ? (
            <>
              <Joyride
                run={run}
                steps={steps}
                continuous
                disableScrollParentFix
                // stepIndex={stepIndex}
                // spotlightClicks={false}
                showProgress
                showSkipButton
                callback={handleJoyrideCallback}
                styles={{
                  options: {
                    zIndex: 10000,
                  },
                }}
              />
            </>
          ) : (
            <></>
          )} */}
        </div>
        <form
          className=""
          onSubmit={handleSubmit(async (data) => {
            setloading(true);

            console.log(data);
            await axiosPrivate
              .get("/listings/FilterMatchCards", {
                withCredentials: true,
                params: {
                  game: data.game, // Example: filtering by game
                  fees: data.fees, // Example: filtering by fee range
                  type: data.type, // Example: filtering by type
                  matchtype: data.matchType, // Example: filtering by match type
                  server: data.server, // Example: filtering by server
                  matchId: data.matchId,
                },
              })
              .then((res) => {
                console.log(res.data);
                setListings(res.data);
                setloading(false);

                // setListings(res.data);
              });
          })}
        >
          <div className="grid md:grid-cols-7 grid-rows-1 gap-4 myfilterstep">
            <div>
              <select
                {...register("game", {
                  required: "This field is required.",
                })}
                className={`block appearance-none  w-full bg-gray-200 border border-gray-200 ${
                  errors.Country?.message ? "border-red-700" : null
                } text-gray-700 py-3 px-4 pr-8 rounded text-xs leading-tight focus:outline-none focus:bg-white focus:border-gray-500 `}
                id="grid-state-country"
                defaultValue="Select Country"
              >
                <option value="PUBG MOBILE" default>
                  PUBG Mobile - Player Unknowns Battle Ground
                </option>
              </select>
            </div>
            <div className="flex  items-center justify-center">
              <div>
                <select
                  {...register("fees", {
                    required: "This field is required.",
                  })}
                  className={`block appearance-none w-full bg-gray-200 border border-gray-200 ${
                    errors.Country?.message ? "border-red-700" : null
                  } text-gray-700 py-3 px-2 pr-6 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 `}
                  id="grid-state-country"
                  defaultValue="Select Fees"
                >
                  <option value="100-1000" default>
                    All (100 - 1000)
                  </option>
                  <option value="100-300" default>
                    100 - 300
                  </option>
                  <option value="300-500" default>
                    300 - 500
                  </option>
                  <option value="500-1000" default>
                    500 - 1000
                  </option>
                </select>
              </div>
              <p className="ms-2 font-bold text-sm">PKR</p>
            </div>
            <div>
              <select
                {...register("type", {})}
                className={`block appearance-none w-full bg-gray-200 border border-gray-200 ${
                  errors.Country?.message ? "border-red-700" : null
                } text-gray-700 py-3 px-1 pr-6  text-xs rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 `}
                id="grid-state-country"
                defaultValue="Select Mode Type"
              >
                <option value="">Select Player Types</option>
                <option value="All">All Player Types</option>
                <option value="single">Single (1)</option>
                <option value="duo">Duo Squad (2)</option>
                <option value="squad">Squad (4)</option>
              </select>
            </div>
            <div>
              <select
                {...register("matchType", {})}
                className={`block appearance-none w-full bg-gray-200 border border-gray-200 ${
                  errors.Country?.message ? "border-red-700" : null
                } text-gray-700 py-3 px-1 pr-6 rounded text-xs leading-tight focus:outline-none focus:bg-white focus:border-gray-500 `}
                id="grid-state-country"
                defaultValue="Select Mode Type"
              >
                <option value="">Select Match Types</option>
                <option value="All">All Match Types</option>
                <option value="Erangle">Erangle</option>
                <option value="Erangle-themed">Erangle-themed</option>
                <option value="Livik">Livik</option>
              </select>
            </div>
            <div>
              <select
                {...register("server", {})}
                className={`block appearance-none w-full bg-gray-200 border border-gray-200 ${
                  errors.Country?.message ? "border-red-700" : null
                } text-gray-700 py-3 px-1 pr-6 rounded text-xs leading-tight focus:outline-none focus:bg-white focus:border-gray-500 `}
                id="grid-state-country"
                defaultValue="Select Mode Type"
              >
                <option value="">Select Server</option>
                <option value="All">All Server Types</option>
                <option value="Europe">Europe</option>
                <option value="Middle-east">Middle-east</option>
                <option value="Asia">Asia</option>
              </select>
            </div>
            <div>
              <input
                {...register("matchId", {})}
                className={`block appearance-none w-full bg-gray-200 border border-gray-200 ${
                  errors.Country?.message ? "border-red-700" : null
                } text-black py-3 px-1 pr-4 rounded text-xs leading-tight focus:outline-none focus:bg-white focus:border-gray-500 `}
                id="grid-state-country"
                placeholder="Search Match by Id"
              />
            </div>
            <div className="">
              <img
                src="https://api.iconify.design/hugeicons:system-update-02.svg?color=%23ffffff"
                className="w-[30px] h-[30px] "
                style={{ cursor: "pointer" }}
                alt="refresh filter"
                onClick={async () => {
                  await axiosPrivate
                    .get("/listings/MatchCards", { withCredentials: true })
                    .then((res) => {
                      console.log(res.data);
                      setListings(res.data);
                      handleReset();
                    });
                }}
              />
            </div>
          </div>
          <div className="flex justify-center">
            <div>
              <button
                type="submit"
                className=" tracking-wide mt-3 font-semibold bg-purple-700 text-white w-full py-3 px-10 rounded-lg hover:bg-purple-900 hover:text-white transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none"
              >
                Search
              </button>
            </div>
          </div>
        </form>
        <div className="m-5 flex justify-center items-center totalMatchesstep">
          {/* <div className="grid  grid-cols-3 grid-rows-1 gap-4 "> */}
          {loading ? (
            <>
              <Loader />
            </>
          ) : listings?.length > 0 ? (
            <>
              <div className="grid  lg:grid-cols-3 md:grid-cols-2 grid-rows-1 gap-4 ">
                {listings.map((listing, index) => {
                  return (
                    <div key={listing?._id} className="singleMatchDetails">
                      <MatchCard key={listing?._id} listing={listing} />
                    </div>
                  );
                })}
              </div>
            </>
          ) : (
            <>
              <div className="w-full flex justify-center rounded-xl items-center h-[400px] bg-black bg-opacity-50">
                <p className="text-gray-400 font-bold">No Matches Found.</p>
              </div>
            </>
          )}
        </div>
        {/* </div> */}

        {/* <button onClick={refresh}>refresh</button> */}
      </div>
    </>
  );
};

export default ECommerce;
